import React from "react";
import styled from "styled-components";
import { P, H1, H2, H3, H4, H5, Description } from "../components/typography";
import { HFlexFlipper } from "../components/blocks/Flex";
import { getThemeColor } from "../utils";
import ImagePaperPlane from "../../assets/paper-plane.png";
import Pad from "./blocks/Pad";

const ContactForm = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const Title = H1.extend`
  ${props => props.theme.media.mobile`
    font-size: 2rem;
  `};
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  padding: 2rem;
  width: 100%;
  max-width: 40rem;
  align-items: stretch;
`;

const inputStyle = `
  flex: 1;
  border-radius: 4px;
  resize: none;
  ::-webkit-input-placeholder {
    color: ${getThemeColor("grey")};
  }
  max-width: 40rem;
  padding: 1rem;
`;

const TextArea = styled.textarea`
  border: 2px solid ${getThemeColor("greyAccent")};
  display: flex;
  height: 9rem;
  ${inputStyle};
`;

const Input = styled.input`
  border: 2px solid ${getThemeColor("greyAccent")};
  flex-grow: 11;
  line-height: 2;
  margin-right: 0rem;
  margin-bottom: .7rem;
  ${inputStyle};
  @media (min-width: 700px) {
    + input {
      margin-left: 1rem;
    }
  }
`;

const SubmitButton = styled.button`
  flex-grow: 1;
  border-radius: 4px;
  border: none;
  background-color: ${getThemeColor("teal")};

  ${props => props.theme.media.mobile`
    margin-left: 0;
    margin-top: 2rem;
  `};
`;

const EmailAndSubmit = styled.div`
  display: flex;
  padding-top: 2rem;
  width: 100%;
  max-width: 40rem;

  ${props => props.theme.media.mobile`
    flex-direction: column;
    padding-top: 0rem;
  `};
`;

const Image = styled.img`
  height: 2rem;
  width: 2rem;
  padding: .5rem;
`;

const FullAddress = styled.div`padding-top: 3rem;`;

const City = H5.extend`
  justify-content: center;
  font-weight: 600;
`;

const Address = P.extend`
  justify-content: center;
  text-align: center;
  padding: 1rem;
  font-size: 1rem;
`;
export default ({ title, address }) =>
  <ContactForm>
    <Pad v={2} />
    <Title>
      {title}
    </Title>
    <Form
      method="POST"
      action="https://q6uiyos8bl.execute-api.us-east-1.amazonaws.com/prod"
    >
      <HFlexFlipper align="stretch">
        <Input placeholder="Name" name="name" id="name" />
        <Input placeholder="Email" name="email" id="email" />
      </HFlexFlipper>
      <TextArea placeholder="Message" rows={4} name="message" id="message" />
      <EmailAndSubmit>
        <SubmitButton type="submit">
          <Image src={ImagePaperPlane} />
        </SubmitButton>
      </EmailAndSubmit>
    </Form>
    <FullAddress>
      <City>Address</City>
      <Address>
        {(address || "").split("|").map(a =>
          <div>
            {a}
          </div>
        )}
      </Address>
    </FullAddress>
  </ContactForm>;



// WEBPACK FOOTER //
// ./src/components/ContactForm.js